"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.clothPricingInverse = exports.addIsSuitableForJunior = exports.addAutoPrices = exports.addAutoId = exports.addAutoComplex = void 0;
exports.enrichWithPricingInverse = enrichWithPricingInverse;
Object.defineProperty(exports, "getUpcyclingInverse", {
  enumerable: true,
  get: function get() {
    return _upcyclingPricing.getUpcyclingInverse;
  }
});
exports.pricingInverse = exports.metadata = exports.leatherGoodsPricingInverse = exports.leatherGoodsPricing = void 0;
Object.defineProperty(exports, "upcyclingPricing", {
  enumerable: true,
  get: function get() {
    return _upcyclingPricing["default"];
  }
});
Object.defineProperty(exports, "upcyclingPricingInverse", {
  enumerable: true,
  get: function get() {
    return _upcyclingPricing.upcyclingPricingInverse;
  }
});
var _rawPricings = _interopRequireDefault(require("./rawPricings"));
var _rawLeatherGoodsPricing = _interopRequireDefault(require("./rawLeatherGoodsPricing"));
var _upcyclingPricing = _interopRequireWildcard(require("./upcyclingPricing"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // *** Version: 9 ***
/* eslint max-len: 0 */
// #####################################################################
// # @README before updating price:                                    #
// # * don't change the id of an item                                  #
// # * don't delete an item, set `hidden: true`                        #
// # * update version at the top of the file and in metadata object    #
// # * @TODO: update price on tilli-site                               #
// #####################################################################

var metadata = exports.metadata = {
  minOrderAmount: 20,
  deliveryFee: 5,
  version: 9,
  mostCommonCategoryName: 'Les plus courants',
  // put positions here rather than directly reorganizing the categories and clothes
  // because it's easier to keep up with the original excel price sheet
  clothPositions: ['pant', 'haut', 'robe', 'mari', 'mant', 'jupe', 'pull', 'deco', 'ling', 'comb', 'acce', 'mask', 'autr', 'crea_tote', 'crea_sac', 'crea_poch', 'crea_hous', 'crea_cana', 'crea_assi', 'crea_doss', 'crea_plai', 'crea_chai', 'crea_stoo', 'crea_ride'],
  categoryPositions: ['Ourlets', 'Raccourcir', 'Cintrer', 'Rallonger', 'Élargir', 'Déchirures / trous', 'Zips', 'Boutons', 'Divers', 'Broderie main', 'Broderie machine', 'Rideaux', 'Coussins', 'Créations']
};
function getClothPosition(clothSlug) {
  return metadata.clothPositions.findIndex(function (clothSlugIt) {
    return clothSlugIt === clothSlug;
  });
}
function sortClothes(clothes) {
  return clothes.sort(function (a, b) {
    return getClothPosition(a.slug) - getClothPosition(b.slug);
  });
}
function getCategoryPosition(categoryName) {
  return metadata.categoryPositions.findIndex(function (categoryNameIt) {
    return categoryNameIt === categoryName;
  });
}
function sortCategories(clothes) {
  return clothes.map(function (cloth) {
    cloth.categories.sort(function (a, b) {
      return getCategoryPosition(a.name) - getCategoryPosition(b.name);
    });
    return cloth;
  });
}
function getMostCommonCategory(cloth) {
  var items = [];
  cloth.categories.forEach(function (cat) {
    return cat.items.forEach(function (item) {
      if (typeof item.mostCommonCategoryPosition === 'number') items.push(item);
    });
  });
  return {
    name: metadata.mostCommonCategoryName,
    slug: 'most_common',
    mostCommonCategory: true,
    items: items.sort(function (a, b) {
      return a.mostCommonCategoryPosition - b.mostCommonCategoryPosition;
    })
  };
}
function addMostCommonCategory(clothes) {
  return clothes.map(function (cloth) {
    if (!cloth.hasMostCommonCategory) return cloth;
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: [getMostCommonCategory(cloth)].concat(_toConsumableArray(cloth.categories))
    });
  });
}
var addAutoPrices = exports.addAutoPrices = function addAutoPrices(clothes) {
  return clothes.map(function (cloth) {
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: !cloth.autoPrices ? cloth.categories : cloth.categories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          items: category.items.map(function (item) {
            if (!item.priceForAllTypes) return _objectSpread({}, item);
            var priceForAllTypes = item.priceForAllTypes;
            var prices = {};
            cloth.types.forEach(function (_ref) {
              var slug = _ref.slug;
              prices[slug] = priceForAllTypes;
            });
            return _objectSpread(_objectSpread({}, item), {}, {
              prices: prices
            });
          })
        });
      })
    });
  });
};
var addAutoComplex = exports.addAutoComplex = function addAutoComplex(clothes) {
  return clothes.map(function (cloth) {
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: !(typeof cloth.autoComplexFactor === 'number') ? cloth.categories : cloth.categories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          items: category.items.map(function (item) {
            var prices = item.prices;
            var newPrices = _objectSpread({}, prices);
            Object.entries(prices).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];
              newPrices[key.replace(/SIMPLE/, 'COMPLEX')] = value * (item.autoComplexFactor || cloth.autoComplexFactor);
            });
            return _objectSpread(_objectSpread({}, item), {}, {
              prices: newPrices
            });
          })
        });
      })
    });
  });
};
var addAutoId = exports.addAutoId = function addAutoId(clothes) {
  return clothes.map(function (cloth) {
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: !cloth.autoId ? cloth.categories : cloth.categories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          items: category.items.map(function (item, index) {
            return _objectSpread(_objectSpread({}, item), {}, {
              id: "".concat(metadata.version, ".").concat(cloth.slug, "-").concat(category.autoIdPrefix, "-").concat(index + 1),
              multiple: category.autoMultiple ? true : undefined
            });
          })
        });
      })
    });
  });
};
var addIsSuitableForJunior = exports.addIsSuitableForJunior = function addIsSuitableForJunior(clothes) {
  return clothes.map(function (cloth) {
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: !cloth.isSuitableForJunior ? cloth.categories : cloth.categories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          items: category.items.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              isSuitableForJunior: true
            });
          })
        });
      })
    });
  });
};
var autoPricesPricings = addAutoPrices(_rawPricings["default"]);
var autoComplexPricings = addAutoComplex(autoPricesPricings);
var autoIdPricings = addAutoId(autoComplexPricings);
var isSuitableForJuniorPricings = addIsSuitableForJunior(autoIdPricings);
var sortedClothes = sortClothes(isSuitableForJuniorPricings);
var sortedClothesAndCategories = sortCategories(sortedClothes);
var pricing = addMostCommonCategory(sortedClothesAndCategories);
var _default = exports["default"] = pricing;
function enrichWithPricingInverse(basePricing) {
  var pricingInverseIt = {};
  basePricing.forEach(function (cloth) {
    if (cloth.subTypes) {
      cloth.types.forEach(function (type) {
        if (pricingInverseIt[type.id]) {
          throw new Error("Inverse pricing, duplicate key : ".concat(type.name));
        }
        pricingInverseIt[type.id] = {
          id: type.id,
          cloth: cloth.name,
          name: type.name,
          prices: _defineProperty({}, type.slug, type.price),
          multiple: true
        };
      });
    }
    cloth.categories.filter(function (cat) {
      return cat.name !== metadata.mostCommonCategoryName;
    }).forEach(function (category) {
      return category.items.forEach(function (item) {
        if (pricingInverseIt[item.id]) {
          throw new Error("Inverse pricing, duplicate key : ".concat(item.name));
        }
        pricingInverseIt[item.id] = _objectSpread(_objectSpread({}, item), {}, {
          cloth: cloth.name,
          category: category.name
        });
      });
    });
  });
  return pricingInverseIt;
}
var clothPricingInverse = exports.clothPricingInverse = enrichWithPricingInverse(pricing);
var leatherGoodsPricing = exports.leatherGoodsPricing = _rawLeatherGoodsPricing["default"];
var leatherGoodsPricingInverse = exports.leatherGoodsPricingInverse = enrichWithPricingInverse(leatherGoodsPricing);
var pricingInverse = exports.pricingInverse = _objectSpread(_objectSpread(_objectSpread({}, clothPricingInverse), leatherGoodsPricingInverse), _upcyclingPricing.upcyclingPricingInverse);